/**
 * Restaura botões Comprar / Carrinho ao voltar do checkout (bfcache).
 * Script clássico (sem module) — sempre ativo após pageshow/pagehide.
 */
(function () {
  var SELECTOR = '[data-md-buy-now], [data-md-sticky-buy-now]';

  function clearBusyDom() {
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      btn.classList.remove('md-pdp__btn--busy');
      btn.removeAttribute('aria-busy');
      delete btn.dataset.mdSubmitting;
    });
  }

  function resetAll() {
    clearBusyDom();
    if (window.AndradePdpCommerce && typeof window.AndradePdpCommerce.resetInstances === 'function') {
      window.AndradePdpCommerce.resetInstances();
    }
  }

  window.addEventListener('pageshow', resetAll);
  window.addEventListener('pagehide', clearBusyDom);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetAll();
  });

  window.AndradePdpCommerce = window.AndradePdpCommerce || {};
  window.AndradePdpCommerce.hardReset = resetAll;
})();
